<template>
  <!-- 资金方账号管理Tab组件 -->
  <div class="accountManagementVO">
    <!-- 资金方账号管理列表 -->
    <el-row style="margin-bottom:20px;">
      <!-- 新增用户按钮 -->
      <el-button
        type="primary"
        class="pool-btn-primary addUserBtn"
        @click="addUserDialogVisible = true"
        >{{ $t("poolOfMoney_page.addUser") }}
      </el-button>
    </el-row>
    <!-- 列表 -->
    <table class="accountManagement-table">
      <thead>
        <tr>
          <th style="width:104px;text-align:left;padding-left: 30px;box-sizing: border-box">
            {{ $t("financingFundList.indexTr") }}
          </th>
          <th style="width:277px">
            {{ $t("poolOfMoney_page.accountNumber") }}
          </th>
          <th style="width:374px">
            {{ $t("poolOfMoney_page.originalEmail") }}
          </th>
          <th style="width:217px">
            {{ $t("poolOfMoney_page.status") }}
          </th>
          <th style="width:228px">{{ $t("poolOfMoney_page.ope") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in accountlist.rows" :key="index">
          <td style="max-width:277px;text-align:left;padding-left: 30px;box-sizing: border-box">
            {{ index + 1 + (pg_st - 1) * 10 }}
          </td>
          <td style="max-width:374px">{{ item.loanName }}</td>
          <td style="max-width:217px">{{ item.email }}</td>
          <td style="max-width:228px">
            <span
              v-show="item.status === 1 ? true : false"
              style="color:#606266;"
            >
              {{ $t("poolOfMoney_page.open") }}</span
            >
            <span
              v-show="item.status === 0 ? true : false"
              style="color:#606266;"
            >
              {{ $t("poolOfMoney_page.close") }}</span
            >
          </td>
          <td>
            <span v-show="!item.isSuper">
              <span @click="showDelMoneyDialog(1, item.id)">
                {{ $t("poolOfMoney_page.delete") }}</span
              >
              <span style="margin:auto 10px;" @click="showSetRightDialog(item)">
                {{ $t("poolOfMoney_page.setRight") }}</span
              >
              <span
                v-show="item.status === 0 ? true : false"
                @click="showDelMoneyDialog(5, item.id)"
              >
                {{ $t("poolOfMoney_page.open") }}</span
              >
              <span
                v-show="item.status === 1 ? true : false"
                @click="showDelMoneyDialog(2, item.id)"
              >
                {{ $t("poolOfMoney_page.close") }}</span
              >
            </span>
            <span
              style="margin-left:10px;"
              :class="item.isSuper ? 'adminSpan' : ''"
              @click="showDelMoneyDialog(3, item.id)"
            >
              {{ $t("poolOfMoney_page.resetPassword") }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 当列表数据为空时显示界面 -->
    <div
      class="statusEmpty"
      v-if="!accountlist.rows || !accountlist.rows.length"
    >
      <i></i>{{ $t("frontPage.noData") }}
    </div>
    <!-- 翻页 -->
    <div class="accountManagement-pagination-box">
      <el-pagination
        style="text-align:center;"
        background
        layout="prev, pager, next"
        class="page-theme"
        :page-size="10"
        :total="total"
        :current-page.sync="pg_st"
        @current-change="getAccountList()"
        v-if="accountlist.rows && accountlist.rows.length"
      ></el-pagination>
    </div>
    <!-- 删除1、禁用2、重置密码3、确认权限的公用对话框 -->
    <el-dialog
      :title="delTitleText"
      :visible.sync="delUserDialogVisible"
      width="500px"
      class="delMoneyDlg"
    >
      <div style="width:500px;height:120px;padding-top:40px;">
        <p class="delUserDialogContent" style="color:#81899E">{{ delUserDialogContent }}</p>
      </div>
      <span class="addMoneySpan">
        <el-button
          class="pool-btn-primary"
          @click="delUser"
          style="margin:0 30px 0 55px;"
          >{{ $t("poolOfMoney_page.ok") }}</el-button
        >
        <el-button
          class="pool-btn-default"
          @click="delUserDialogVisible = false"
          style="margin:0;"
          >{{ $t("poolOfMoney_page.no") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增用户对话框 -->
    <el-dialog
      :title="this.$t('poolOfMoney_page.addUser')"
      :visible.sync="addUserDialogVisible"
      width="500px"
      @close="addUserDialogClosed"
      class="addUserDlg"
    >
      <el-form
        :model="addUserForm"
        :rules="addUserFormRules"
        ref="addUserFormRef"
        label-width="120px"
      >
        <el-form-item
          class="addUserInput"
          :label="this.$t('poolOfMoney_page.accountNumber')"
          prop="id"
          style="maegin-bottom:7px; padding:0;"
        >
          <el-input
            :placeholder="this.$t('poolOfMoney_page.inputUserName')"
            v-model.trim="addUserForm.id"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('poolOfMoney_page.email')"
          prop="email"
          style="maegin:0 ;padding:0;"
        >
          <el-input
            :placeholder="this.$t('poolOfMoney_page.inputEmail')"
            v-model.trim="addUserForm.email"
          ></el-input>
        </el-form-item>
      </el-form>
      <span class="addMoneySpan">
        <el-button
          class="pool-btn-primary"
          @click="addUser"
          style="margin:0 30px 0 55px;"
          >{{ $t("poolOfMoney_page.ok") }}</el-button
        >
        <el-button
          class="pool-btn-default"
          @click="addUserDialogVisible = false"
          style="margin:0;"
          >{{ $t("poolOfMoney_page.no") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 分配权限的对话框 -->
    <el-dialog
      :title="this.$t('poolOfMoney_page.rightSet')"
      :visible.sync="setRightDialogVisible"
      width="500px"
      @close="setRightDialogClosed"
    >
      <!-- 树形控件 -->
      <el-tree
        :data="menuList"
        :props="treeprops"
        node-key="id"
        :default-checked-keys="defKeys"
        :default-expanded-keys="[1]"
        show-checkbox
        ref="treeRef"
        style="padding-left:106px;margin:20px 0 30px 0;"
        @check="CheckedKeys"
      >
      </el-tree>
      <span class="addMoneySpan">
        <el-button
          class="pool-btn-primary"
          @click="showDelMoneyDialog(4)"
          style="margin:0 30px 0 55px;"
          >{{ $t("poolOfMoney_page.ok") }}</el-button
        >
        <el-button
          class="pool-btn-default"
          @click="setRightDialogVisible = false"
          style="margin:0;"
          >{{ $t("poolOfMoney_page.no") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "accountManagement",
  // props: ["admin"],
  data() {
    // 验证邮箱的校验规则
    let checkUserEmail = (rule, value, cb) => {
      const regUserEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!value) {
        return cb(new Error(this.$t("poolOfMoney_page.emailNo")));
      } else if (!regUserEmail.test(value)) {
        cb(new Error(this.$t("poolOfMoney_page.emailFormat")));
      } else {
        cb();
      }
    };
    // 校验账号的验证规则
    let checkUserId = (rule, value, cb) => {
      const regUserId = /^[a-zA-Z0-9]{6,16}$/;
      if (!value) {
        return cb(new Error(this.$t("poolOfMoney_page.nameNo")));
      } else if (!regUserId.test(value)) {
        return cb(new Error(this.$t("poolOfMoney_page.nameFormat")));
      } else {
        cb();
      }
    };
    return {
      value: "",
      accountlist: {
        rows: []
      },
      // 当前页码
      pg_st: 1,
      total: 0,
      delTitleText: "",
      delUserDialogContent: "",
      delUserDialogVisible: false,
      addUserDialogVisible: false,
      setRightDialogVisible: false,
      addUserForm: {
        id: "",
        email: ""
      },
      addUserFormRules: {
        email: [{ validator: checkUserEmail, trigger: "click" }],
        id: [{ validator: checkUserId, trigger: "click" }]
      },
      // 权限数据
      menuList: [],
      treeprops: {
        label: "name",
        children: "children"
      },
      // 默认选中的节点id值数组
      defKeys: [],
      // 被修改权限人id
      rightId: "",
      // 被操作人id
      operationId: "",
      // 操作类型：1删除，2禁用 ，3重置，4确认权限
      delNum: ""
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    isSuper() {
      return this.userProfile.isSuper;
    }
  },
  methods: {
    // 1.点击查看，其他随意 2.点击其他，查看也要被勾 3.取消查看，其他选项也取消
    CheckedKeys(val, status) {
      // 联动查看的id数组,对应的父节点数组
      let viewArr = [132, 136, 140, 154];
      let viewFather = [127, 128, 129, 130];
      // 资金池的两个查看，两个都没有，父节点没有，没有159，就没有160.  有了160，就得有159
      if (!val.children) {
        // 被check的节点是联动查看节点
        if (viewArr.indexOf(val.id) > -1) {
          // 如果是联动查看节点被取消，其父节点只能是半选状态或没有选择状态
          if (status.checkedKeys.indexOf(val.id) == -1) {
            // 如果父节点是半选状态，除了联动查看，还有其他伙伴被选中，取消父节点选中状态，进而取消其他伙伴
            if (status.halfCheckedKeys.indexOf(val.pId) > -1) {
              this.$refs.treeRef.setChecked(val.pId, false, true);
            }
          }
        } else if (val.id == 159) {
          if (status.checkedKeys.indexOf(159) == -1) {
            this.$refs.treeRef.setChecked(160, false, true);
          }
        }
        // 如果被check的节点是联动查看的兄弟节点,查看也要被勾选
        else if (viewFather.indexOf(val.pId) > -1) {
          if (val.pId == 127) {
            this.$refs.treeRef.setChecked(132, true, true);
          }
          if (val.pId == 128) {
            this.$refs.treeRef.setChecked(136, true, true);
          }
          if (val.pId == 129) {
            this.$refs.treeRef.setChecked(140, true, true);
          }
          if (val.pId == 130) {
            this.$refs.treeRef.setChecked(154, true, true);
          }
        } else if (val.id == 160) {
          this.$refs.treeRef.setChecked(159, true, true);
        }
      }
    },

    // 获取账号管理列表
    getAccountList() {
      let params = {
        pg_st: this.pg_st,
        pg_rs: 10
      };
      this.axios.post("/zma/api/zmaLoanAccountUser/list", params).then(res => {
        console.log("账号管理");
        console.log(res);
        if (res.status) {
          this.accountlist.rows = res.data.rows;
          this.total = res.data.total;
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
        }
      });
    },
    // 调用权限接口+展示权限分配对话框
    showSetRightDialog(right) {
      this.rightId = right.id;
      let params = {
        u_d: this.rightId
      };
      // 调用初始化权限树接口
      this.axios.post("/api/zma/loanMenu/getMenuList").then(res1 => {
        console.log("初始化权限树");
        console.log(res1);
        if (res1.status) {
          let resArr = [res1.data];
          this.menuList = resArr;
          // 调用被修改人权限
          this.axios.post("/api/zma/loanMenu/getRole", params).then(res2 => {
            console.log("被修改人权限");
            console.log(res2);
            if (res2.status) {
              this.defKeys = res2.data.menuIdList;
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res2.errorCode}`)
              );
            }
            this.setRightDialogVisible = true;
          });
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res1.errorCode}`));
        }
      });
    },

    // 展示删除1、禁用2、重置密码3、确认权限4,启用5的公用对话框
    showDelMoneyDialog(del, id) {
      this.operationId = id;
      if (del === 1) {
        this.delNum = 1;
        this.delTitleText = this.$t("poolOfMoney_page.delete");
        this.delUserDialogContent = this.$t("poolOfMoney_page.deleteConfirm");
      } else if (del === 2) {
        this.delNum = 2;
        this.delTitleText = this.$t("poolOfMoney_page.close");
        this.delUserDialogContent = this.$t("poolOfMoney_page.closeConfirm");
      } else if (del === 3) {
        this.delNum = 3;
        this.delTitleText = this.$t("poolOfMoney_page.resetPassword");
        this.delUserDialogContent = this.$t("poolOfMoney_page.resetConfirm");
      } else if (del === 4) {
        this.delNum = 4;
        this.delTitleText = this.$t("poolOfMoney_page.saveRight");
        this.delUserDialogContent = this.$t("poolOfMoney_page.saveRightOk");
      } else {
        this.delNum = 5;
        this.delTitleText = this.$t("poolOfMoney_page.open");
        this.delUserDialogContent = this.$t("poolOfMoney_page.openOk");
      }
      this.delUserDialogVisible = true;
    },

    // 调用 1删除、2禁用、3重置密码、4确认权限 、5启用的接口
    delUser() {
      let params = {
        in_id: this.operationId
      };
      if (this.delNum == 1) {
        this.axios
          .post("/zma/api/zmaLoanAccountUser/del", params)
          .then(res1 => {
            console.log("删除");
            console.log(res1);
            if (res1.status) {
              this.$message.success(this.$t("poolOfMoney_page.opeOk"));
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res1.errorCode}`)
              );
            }
            this.getAccountList();
          });
      } else if (this.delNum == 2) {
        this.axios
          .post("/zma/api/zmaLoanAccountUser/forbidden", params)
          .then(res2 => {
            console.log("禁用");
            console.log(res2);
            if (res2.status) {
              this.$message.success(this.$t("poolOfMoney_page.opeOk"));
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res2.errorCode}`)
              );
            }
            this.getAccountList();
          });
      } else if (this.delNum == 3) {
        this.axios
          .post("/zma/api/zmaLoanAccountUser/password", params)
          .then(res3 => {
            console.log("重置密码");
            console.log(res3);
            if (res3.status) {
              this.$message.success(this.$t("poolOfMoney_page.opeOk"));
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res3.errorCode}`)
              );
            }
            this.getAccountList();
          });
      } else if (this.delNum == 4) {
        // 点击确认之后，确认权限关闭，分配权限关闭，更新权限
        let keys = [...this.$refs.treeRef.getCheckedKeys()];
        let keysStr = keys.join(",");
        let params = {
          loanAccountId: this.rightId,
          roleIds: keysStr
        };
        this.axios.post("/api/zma/loanMenu/saveMenu", params).then(res4 => {
          console.log("保存权限");
          console.log(res4);
          if (res4.status) {
            this.$message.success(this.$t("poolOfMoney_page.opeOk"));
          } else {
            this.$message.error(this.$t(`poolOfMoney_error.${res4.errorCode}`));
          }
        });
        this.setRightDialogVisible = false;
      } else if (this.delNum == 5) {
        this.axios
          .post("/zma/api/zmaLoanAccountUser/enable", params)
          .then(res => {
            console.log("启用");
            console.log(res);
            if (res.status) {
              this.$message.success(this.$t("poolOfMoney_page.opeOk"));
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              );
            }
            this.getAccountList();
          });
      }
      this.delUserDialogVisible = false;
    },
    // 权限分配对话框关闭后，选择项重置
    setRightDialogClosed() {
      this.defKeys = [];
    },
    // 关闭添加用户对话框时清空数据
    addUserDialogClosed() {
      this.$refs.addUserFormRef.resetFields();
    },
    // 校验添加用户+调接口+关闭对话框+刷新账号列表
    addUser() {
      this.$refs.addUserFormRef.validate(valid => {
        if (!valid) return;
        let params = {
          in_na: this.addUserForm.id,
          in_em: this.addUserForm.email
        };
        this.axios
          .post("/zma/api/zmaLoanAccountUser/apply", params)
          .then(res => {
            console.log("增加用户");
            console.log(res);
            if (res.status) {
              console.log("增用成功！");
              this.getAccountList();
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              );
            }
          });
        this.addUserDialogVisible = false;
      });
    }
  },
  created() {
    this.getAccountList();
  }
};
</script>
<style lang="scss" scoped>
.pool-btn-primary {
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
}
.pool-btn-default {
  width: 150px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #7996f5;
  border-radius: 2px;
  color: #7996f5;
}
.addUserBtn {
  float: right;
  margin-right: 30px;
}
.accountManagement {
  font-size: 14px;

  &-pagination-box {
    padding: 30px 0;
  }
  &-table {
    width: 100%;
    border: none;
    font-weight: normal;
    color: #606266;
    text-align: left;
    border-collapse: collapse;
    thead {
      height: 50px;
      line-height: 50px;
      color: #828baf;
      background: #f8fafd;
    }
    th {
      padding: 0;
      height: 50px;
      font-weight: normal;
      text-align: left;
    }
    td {
      height: 60px;
      padding: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .adminSpan {
        margin: 0 !important;
      }
    }
    span {
      color: #7996f5;
      cursor: pointer;
    }
  }
}
.addMoneySpan {
  box-sizing: border-box;
  display: inline-block;
  width: 440px;
  height: 70px;
  box-shadow: inset 0 1px 0 0 #eaeaea;
  margin-left: 30px;
  padding-top: 16px;
}
.delUserDialogContent {
  width: 350px;
  height: 40px;
  margin: 0 auto;
  text-align: center;
}
</style>
